var _path, _path2, _path3, _path4, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 122,
    height: 128,
    viewBox: "0 0 122 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 118.588V26.4174C4 25.6378 4.63197 25.0059 5.41154 25.0059H35.6687C36.1364 25.0059 36.5737 25.2375 36.8364 25.6243L42.0744 33.3361C42.3371 33.723 42.7744 33.9546 43.242 33.9546H102.539C103.318 33.9546 103.95 34.5865 103.95 35.3661V118.588C103.95 119.368 103.318 120 102.539 120H5.41154C4.63197 120 4 119.368 4 118.588Z",
    fill: "#F5C347"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1484 87.1073L25.1484 20.7144L44.7702 0L94.8126 0C95.6216 0 96.2774 0.655772 96.2774 1.46471V87.1073C96.2774 87.9162 95.6216 88.572 94.8126 88.572H26.6131C25.8042 88.572 25.1484 87.9162 25.1484 87.1073Z",
    fill: "#8BCCFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7702 0L25.1484 20.7144H43.3055C44.1144 20.7144 44.7702 20.0586 44.7702 19.2497V0Z",
    fill: "#E1F3FD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M57.0485 24.7064H78.6091M43.3281 33.8394H78.6091M43.3281 43.2579H78.6091M43.3281 52.6763H78.6091M43.3281 62.3802H78.6091",
    stroke: "white",
    strokeWidth: 2.52777,
    strokeLinecap: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_317_757)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.3453 48.2891L4.23417 118.45C4.11246 119.101 4.61221 119.703 5.27481 119.703H103.518C104.026 119.703 104.463 119.342 104.558 118.842L117.894 48.6813C118.018 48.029 117.518 47.4249 116.854 47.4249H18.386C17.8763 47.4249 17.4389 47.7881 17.3453 48.2891Z",
    fill: "#FFD05C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_317_757",
    x: 0.216797,
    y: 47.4249,
    width: 121.695,
    height: 80.2781,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_317_757"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_317_757",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.71d9740186ce939e6c84dd865d75339b.svg";
export { ForwardRef as ReactComponent };